import Modal from "components/blocks/Modal";
import RichTextEditor from "components/RichTextEditor";
import { useState } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CreateCourseOrderRequest } from "services/courseOrder/models/CourseOrderType";
import { CourseDetailsResult } from "services/courseService/models/CourseType";
import {SafeHtmlRenderer} from "../../../../../components/safeHtmlRendererComponant/SafeHtmlRenderer";

type RulesAndConditionSectionProps = {
  register: UseFormRegister<CreateCourseOrderRequest>;
  errors: FieldErrors<CreateCourseOrderRequest>;
  courseDetails?: CourseDetailsResult;
    readOnly?:boolean
};

const RulesAndConditionSection = ({ register, errors, courseDetails,readOnly }: RulesAndConditionSectionProps) => {
  const { t, i18n } = useTranslation(["Orders", "Common"]);
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  const onRuleAndConditionsClicked = () => {
    setModalProps({
      isOpen: true,
      title: courseDetails?.ruleAndConditionName ?? "",
      body: courseDetails?.ruleAndConditionTemplate ?? "",
    });
  };

  const onCommitmentClicked = () => {
    setModalProps({
      isOpen: true,
      title: courseDetails?.commitmentName ?? "",
      body: courseDetails?.commitmentTemplate ?? "",
    });
  };

  return (
    <div className="p-3">
      <div>
        <div>
          <input
            type="checkbox"
            disabled={readOnly}
            className="mx-1 text-primary fw-bold form-check-input"
            {...register("acceptTermsAndCondition")}
          />
          <label htmlFor="isAcceptedConditionAndRules">
            <div className="d-flex gap-1">
              {t("accept")}
              <button
                type="button"
                onClick={onRuleAndConditionsClicked}
                className="btn btn-link p-0 text-primary fw-bold "
              >
                {t("conditionsAndRules")}
              </button>
            </div>
          </label>
        </div>

        {errors.acceptTermsAndCondition && (
          <div
            className="invalid-feedback mb-2"
            style={{
              display: "block",
            }}
          >
            {errors.acceptTermsAndCondition.message}
          </div>
        )}
      </div>

      <div className="mb-2">
        <div>
          <input type="checkbox"      disabled={readOnly} className="mx-1 form-check-input" {...register("acceptAmendments")} />
          <label htmlFor="acceptAmendments">
            <div className="d-flex gap-1">
              {t("accept")}
              <button type="button" onClick={onCommitmentClicked} className="btn btn-link text-primary fw-bold p-0">
                {t("commitment")}
              </button>
            </div>
          </label>
        </div>
        {errors.acceptAmendments && (
          <div
            className="invalid-feedback my-2"
            style={{
              display: "block",
            }}
          >
            {errors.acceptAmendments.message}
          </div>
        )}
      </div>

      {/*<span className="fw-bold fs-12px mt-4">{t("createOrderNote")}</span>*/}

      <Modal
        isOpen={modalProps.isOpen}
        onClose={() => setModalProps({ ...modalProps, isOpen: false })}
        title={modalProps.title}
        containerClassName="bg-white "
        size="lg"
      >
        <SafeHtmlRenderer htmlContent={modalProps.body ?? ""} />
      </Modal>
    </div>
  );
};

export default RulesAndConditionSection;
